import { useParams } from 'react-router-dom';
import AddNodeBody from './components/addNodeBody';

const AddNode = () => {
  const { id } = useParams<{ id: string }>();
  return <AddNodeBody networkId={id || ''} />;
};
export default AddNode;
